export default __webpack_public_path__ + "static/media/ArrowRight.c3a7af5e.svg";